// Based on src/pages/settings/ChangePassword.jsx

import React, { useState } from 'react'

import { Input, Button } from '@st-operations/uikit/src/v2/index.js'

import { useLocation, useHistory } from 'react-router-dom'
import API from '@st-operations/uikit/API.js'
import { useUser } from '_hooks'
import User from '_lib/User'

const BUTTON_STYLE = {
  display: 'table',
  width: 'inherit',
  margin: 0,
}

const INITIAL_STATE = {
  newPassword: '',
  confirmNewPassword: '',
}

// component
const ResetPasswordPage = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const prt = queryParams.get('prt')

  const history = useHistory()

  useUser()
  const [formValues, setFormValues] = useState(INITIAL_STATE)

  const handleChange = (value, name) => {
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const { newPassword, confirmNewPassword } = formValues

    if (newPassword !== confirmNewPassword) {
      toast.error('Entered passwords do not match!')
      return
    }

    if (newPassword === '') {
      toast.error('Password cannot be empty!')
      return
    }

    let params = {
      code: prt,
      password: newPassword,
    }
    let sso_api = new API('https://sso.sharethis.com')
    sso_api.post('/reset-password', params, (err) => {
      if (err) {
        let msg = err && err.message ? err.message : 'error'
        toast.error(msg)
      } else {
        let msg = 'your password has been updated'
        toast(msg)
        setTimeout(() => {
          history.push('/login')
        }, 2000)
      }
    })
  }

  return (
    <form id="change-password" className="max-w-xl mx-auto" onSubmit={handleSubmit}>
      <Input
        onChange={handleChange}
        value={formValues.newPassword}
        placeholder="New password"
        label="New password"
        name="newPassword"
        type="password"
        // autocomplete="new-password"
      />
      <Input
        onChange={handleChange}
        value={formValues.confirmNewPassword}
        placeholder="Confirm new password"
        label="Confirm new password"
        type="password"
        name="confirmNewPassword"
        // autocomplete="new-password"
      />
      <div className="button-container">
        <Button type="submit" style={BUTTON_STYLE}>
          Update Password
        </Button>
      </div>
    </form>
  )
}
// export
export default ResetPasswordPage
